<template>
  <div>
    <h3>This is the Product page.</h3>
  </div>
</template>

<script>
export default {
  name: 'product',
};
</script>
